export default __webpack_public_path__ + "locales/lo-LA/Notifications.json?hash=53cbe1c24dc609510e5f111cc453182e";